import { useContext } from "react"
import { Stack, Typography, Avatar, Button, Box } from "@mui/material"
import { ToolContext } from "../../../../../../core/context/ToolContext"
import { NothingToSee } from "../../../../empty/Index"

export const Design = () => {
    const { marketing_camp } = useContext(ToolContext)
    const { trngForm, trngCustom } = marketing_camp
    const splt = trngCustom.data.split('-')

    const handleBgImg = (e) => {
        const { files } = e.target;
        const bgimage = URL.createObjectURL(files[0]);
        trngForm.set((p) => ({ ...p,
            bgimage: { ...p.bgimage, value: bgimage, file: files[0] }
        }))
    }

    const handlerChangeColor = (e) => {
        const { name, value } = e.target;
        if (trngCustom.data.includes('-')) {
            trngForm.set((p) => {
                const currSpkrs = [ ...p[splt[0]] ]
                currSpkrs[Number(splt[2])] = {
                    ...currSpkrs[Number(splt[2])],
                    [splt[1]]: { 
                        ...currSpkrs[Number(splt[2])][splt[1]], 
                        color: value
                    } 
                }
                return { ...p, speakers: currSpkrs }
            })
            return
        }
        trngForm.set((p) => ({
            ...p,
            [trngCustom.data]: { 
                ...p[trngCustom.data], 
                ...(name === 'color' ? { color: value } : name === 'bg_color' ? { bg_color: value } : { border_color: value })
            }
        }))
    }

    const handleFooter = (e) => {
        const { name, value } = e.target        
        trngForm.set((p) => ({
            ...p,
            [name]: { 
                ...p[name], 
                bg_color: value
            }
        }))
    }

    return (
        <Stack width='100%' mt='1rem' gap='1.5rem'>
            { !trngCustom.data && <NothingToSee text="Please click somewhere on the poster"/>}
            { trngCustom.data === 'bg_image' &&
                <Stack gap='0.5rem' width='100%'>
                    <Typography fontWeight={600}>Background Image</Typography>
                    {/* <Box component="img" src={trngForm.data?.bgimage.value} alt='bg_image' sx={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}/> */}
                    <Stack alignItems='center'>
                        <Avatar variant="square" src={trngForm.data?.bgimage.value} alt="background-img" 
                            sx={{width: 120, height: 120/*, border: inputs.bg_image.type === 'default' ? "1px solid red" : "0px"*/}}
                        />
                    </Stack>
                    <Button component="label" variant="outlined" sx={{ mt: '1rem', alignSelf: 'center', color: '#003022', borderRadius: '6px', fontSize: '14px', fontWeight: '600', border: '2px solid #003F2E', ':hover': { bgcolor: '#edf3eeff', border: '2px solid #003F2E' } }}>
                        Change
                        <Box component="input" type="file" accept="image/*" hidden onChange={handleBgImg}/>
                    </Button>
                </Stack>
            }
            { trngCustom.data === 'footer' &&
                <>
                    <Stack alignItems='center' gap='0.5rem' direction='row'>
                        <Typography fontWeight={600} sx={{ flex: 1, maxWidth: '60%' }}>Background Color</Typography>
                        <Box component="input" type="color" name='footer' onChange={handleFooter} value={trngForm.data?.footer.bg_color}/>
                    </Stack>
                    <Stack alignItems='center' gap='0.5rem' direction='row'>
                        <Typography fontWeight={600} sx={{ flex: 1, maxWidth: '60%' }}>Divider Color</Typography>
                        <Box component="input" type="color" name='divider' onChange={handleFooter} value={trngForm.data?.divider.bg_color}/>
                    </Stack>
                </>
            }
            { (trngCustom.data && trngCustom.data !== 'bg_image' && trngCustom.data !== 'footer') &&
            <Stack gap='0.5rem' width='100%' alignItems='center' direction='row'>
                <Typography fontWeight={600} sx={{ flex: 1, maxWidth: '60%' }}>{trngCustom.data === 'calendar' ? 'Calendar Icon Color' : 'Text Color'}</Typography>
                <Box component="input" type="color" name='color' value={trngForm.data?.[trngCustom.data]?.color || trngForm.data?.[splt[0]]?.[splt[2]]?.[splt[1]]?.color || '#000000'} onChange={handlerChangeColor}/>
            </Stack>
            }
            { (trngCustom.data === 'button' || trngCustom.data === 'calendar') && 
                <Stack gap='0.5rem' width='100%' alignItems='center' direction='row'>
                    <Typography fontWeight={600} sx={{ flex: 1, maxWidth: '60%' }}>Background Color</Typography>
                    <Box component="input" type="color" name='bg_color' value={trngForm.data?.[trngCustom.data]?.bg_color || '#000000'} onChange={handlerChangeColor}/>
                </Stack>
            }
            { trngCustom.data === 'calendar' && 
                <Stack gap='0.5rem' width='100%' alignItems='center' direction='row'>
                    <Typography fontWeight={600} sx={{ flex: 1, maxWidth: '60%' }}>Border Color</Typography>
                    <Box component="input" type="color" name='border_color' value={trngForm.data?.[trngCustom.data]?.border_color || '#000000'} onChange={handlerChangeColor}/>
                </Stack>
            }
        </Stack>
    )
}
